import { RoutePaths } from "@/config/route-paths";
import { AppBreadcrumbsBuilder } from "@/lib/breadcrumbs";
import type { IBreadcrumbItem } from "@cmde/shadcn";
import i18next from "i18next";

export const getCredentialsListBreadcrumbs = ({
  sport,
  customerId,
  customerName,
  organizationId,
  organizationName,
}: {
  customerId: number;
  organizationId: string;
  organizationName: string;
  sport: string;
  customerName?: string;
}): IBreadcrumbItem[] => {
  return AppBreadcrumbsBuilder.start()
    .withSportradar()
    .withStatsAdmin()
    .withCustomer({ customerId, customerName })
    .withOrganization({ customerId, organizationId, organizationName: organizationName })
    .withBreadcrumb({
      title: i18next.t("credentials.list.breadcrumbs.credentials"),
      href: RoutePaths.credentials.list({ customerId, organizationId, sport }),
    })
    .build();
};
